import { render, staticRenderFns } from "./SendMailYn.vue?vue&type=template&id=38d77338&scoped=true&"
import script from "./SendMailYn.vue?vue&type=script&lang=js&"
export * from "./SendMailYn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d77338",
  null
  
)

export default component.exports